import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import "./ProductGallery.scss"

@Component
export class ProductGallery extends ThemeComponent {

}
